import { render, staticRenderFns } from "./QuestionListItemGroup.vue?vue&type=template&id=8601ee2a&scoped=true&"
import script from "./QuestionListItemGroup.vue?vue&type=script&lang=ts&"
export * from "./QuestionListItemGroup.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionListItemGroup.vue?vue&type=style&index=0&id=8601ee2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8601ee2a",
  null
  
)

export default component.exports